export default "__VITE_ASSET__B8x3Dsfz__"